import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES, type SupportedLanguage } from '@/i18n/config';

export const PROFILE_LANGUAGES = SUPPORTED_LANGUAGES;

export function normalizeProfileLanguage(language: string | undefined): SupportedLanguage {
  const normalizedLanguage = (language || DEFAULT_LANGUAGE).trim().toLowerCase();
  const languageCode = normalizedLanguage.startsWith('pt')
    ? 'pt-br'
    : normalizedLanguage.split('-')[0];

  return (
    SUPPORTED_LANGUAGES.find(({ code }) => code.toLowerCase() === languageCode)?.code ??
    DEFAULT_LANGUAGE
  );
}
